import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetMachineRejectsResData } from "./GetMachineRejectsResData";

const ENDPOINT = "/log_analysis/reject";

export class GetMachineRejectsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetMachineRejectsReqData = null;

    constructor(params: GetMachineRejectsReqData) {
        super();
        this.params = { ...params };
    }

    public async execute(): Promise<GetMachineRejectsResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetMachineRejectsResData(res);
    }
}

export class GetMachineRejectsReqData {
    // FilterInstallations
    installationName: string = null;
    serialNumber: string = null;
    dateStart: Date = null;
    dateEnd: Date = null;

    constructor(installationName: string, serialNumber: string, dateStart: Date, dateEnd: Date) {
        this.installationName = installationName;
        this.serialNumber = serialNumber;
        this.dateStart = dateStart;
        this.dateEnd = dateEnd;
    }
}
